"use strict";

var React = require("react"),
    Icon = require("./Icon.js"),
    AddIcon = function AddIcon(e) {
  return React.createElement(Icon, e, React.createElement("path", {
    fillRule: "nonzero",
    d: "M11 9h6v2h-6v6H9v-6H3V9h6V3h2v6z"
  }));
};

module.exports = AddIcon;